import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { AssinaturaLista } from "components/assinatura/AssinaturaLista";
import { AssinaturaDetalhes } from "components/assinatura/AssinaturaDetalhes";

export class Assinaturas extends Component {
  constructor (props) {
    super(props);

    this.state = {
      pending: false
    };
  }

  render () {
    const { props, state } = this;
    const { location, match, history } = props;

    if (state.pending === true) {
      return (
        <div>
          Carregando...MEH
        </div>
      );
    }

    if (match.params.subscriberId !== undefined) {
      let sanitizedId = match.params.subscriberId.replace(/[^\d]/, "");
      sanitizedId = parseInt(sanitizedId);

      if (!isNaN(sanitizedId)) {
        return (
          <AssinaturaDetalhes 
            subscriberId={sanitizedId}/>
        );
      } else {
        history.push("/assinaturas");
      }
    }

    return (
      <AssinaturaLista/>
    );
  }
}
